<template>
    <section class="section-home" >
      <h3>Cientos de desafíos para aprender, crear y compartir</h3>
      <img
      src="public/images/site/challenges.svg"
      id="challenges"
      alt="Miles de proyectos"
      style="padding-top: 50px; padding-bottom:50px"
    />
  </section>
</template>

<script>
import { mapGetters } from 'vuex'

  export default {
    
    name: 'project-banner',

    data () {
      return {
        errorMessage:"",
        login:{
          usuario:"",
          password:""
          }
      }
    },

    computed:{
    ...mapGetters(['pathAPI','userLogged']),

    },

    methods:{
     
    },

    computed:{

    }
        ,
    components:{

    },

    mounted: function(){

    },


  }
</script>

<style>
.section-home{
  margin-top: 100px; 
  max-width: 900px; 
  margin:auto; 
  text-align:center
}
@media screen and (max-width: 800px) {
.section-home{
  max-width: 350px; 
  margin:auto; 
  text-align:center
}

}

</style>


// WEBPACK FOOTER //
// src/components/startPage/ProjectBanner.vue